import 'slick-carousel'
import { createApp } from 'vue'
import FadeIn from '~/js/components/fadeIn'
import FraisCarousel from '~/js/components/fraisCarousel'
import FraisCountDown from '~/js/components/fraisCountDown'
import { BREAKPOINT_WIDTH } from '~/js/constants/breakpoints'

const CLASS_NAME_FRAIS_2026 = 'js-frais-2026'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME_FRAIS_2026)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    const datetimeOpen = new Date(element.dataset.datetimeOpen)

    createApp({
      name: 'SectionsFrais2026',
      components: { FadeIn, FraisCarousel, FraisCountDown },
      data() {
        return {
          datetimeCountDown: datetimeOpen,
          isLoaded: false,
          isMenuOpen: false,
          isMemoryBarInView: false,
        }
      },
      mounted() {
        const memoryBar = this.$refs.memoryBar
        if (memoryBar) {
          const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setTimeout(() => {
                  this.isMemoryBarInView = true
                }, 500)
                observer.disconnect()
              }
            })
          })
          observer.observe(memoryBar)
        }

        const elementNewsCarousel = this.$refs.newsCarousel
        if (elementNewsCarousel) {
          Array.from(elementNewsCarousel.children).forEach((child) => {
            if (!child.innerText) child.remove()
          })
          $(elementNewsCarousel).slick({
            centerMode: true,
            slidesToShow: 1,
            prevArrow: $(this.$refs.newsCarouselPrev),
            nextArrow: $(this.$refs.newsCarouselNext),
            centerPadding: 'calc(50% - 150px)',
            responsive: [
              {
                breakpoint: BREAKPOINT_WIDTH,
                settings: {
                  centerPadding: 'calc(50% - 120px)',
                },
              },
            ],
          })
        }

        setTimeout(() => {
          this.isLoaded = true
          document.body.style.overflow = 'visible'
        }, 3000)
      },
      methods: {
        toggleMenu() {
          this.isMenuOpen = !this.isMenuOpen
        },
      },
    }).mount(element)
  })
})
